/* src/app/indirect-rate/indirect-rate-history/indirect-rate-history-container/indirect-rate-history-container.component.scss */
/*# sourceMappingURL=indirect-rate-history-container.component.css.map */
